import * as THREE from 'three';
import { store } from '../../../store/store';
export class Events {
    constructor(camera, isMobile) {
        this.fwdValue = 0;
        this.bkdValue = 0;
        this.rgtValue = 0;
        this.lftValue = 0;
        this._forward = false;
        this._backward = false;
        this._left = false;
        this._right = false;
        this.isMobile = isMobile;
        this.walkingSpeed = 1.85;
        this.walkingMobileSpeed = .2;
        this.currentCamera = camera;
        store.currentSession.subscribe(value => {
            this.playerIsInScene = value;
        });
        this.render(camera);
    }
    get backward() {
        return this._backward;
    }
    set backward(value) {
        this._backward = value;
    }
    get forward() {
        return this._forward;
    }
    set forward(value) {
        this._forward = value;
    }
    get left() {
        return this._left;
    }
    set left(value) {
        this._left = value;
    }
    get right() {
        return this._right;
    }
    set right(value) {
        this._right = value;
    }
    handleUserDirection(camera) {
        if (this.isMobile) {
            this.frontVector = new THREE.Vector3(0, 0, Number(this.bkdValue) - Number(this.fwdValue));
            this.sideVector = new THREE.Vector3(Number(this.lftValue) - Number(this.rgtValue), 0, 0);
        }
        else {
            this.frontVector = new THREE.Vector3(0, 0, Number(this.backward) - Number(this.forward));
            this.sideVector = new THREE.Vector3(Number(this.left) - Number(this.right), 0, 0);
        }
        // console.log(this.frontVector);
        this.userDirection = new THREE.Vector3();
        this.userDirection
            .subVectors(this.frontVector, this.sideVector)
            .normalize()
            .multiplyScalar(this.walkingSpeed)
            .applyEuler(camera.rotation);
    }
    render(camera) {
        const _camera = camera;
        this.handleUserDirection(camera);
        window.requestAnimationFrame(() => this.render(_camera));
    }
    handleKeyUpEvents() {
        window.addEventListener('keyup', e => {
            if (e.key === 's') {
                this.backward = false;
            }
            if (e.key === 'w') {
                this.forward = false;
            }
            if (e.key === 'a') {
                this.left = false;
            }
            if (e.key === 'd') {
                this.right = false;
            }
        });
    }
    handleKeyDownEvents() {
        window.addEventListener('keydown', e => {
            if (this.playerIsInScene) {
                if (e.key === 's') {
                    this.backward = true;
                }
                if (e.key === 'w') {
                    this.forward = true;
                }
                if (e.key === 'a') {
                    this.left = true;
                }
                if (e.key === 'd') {
                    this.right = true;
                }
                if (e.key === 'q') {
                    console.log('x :' + this.currentCamera.position.x);
                    console.log('y :' + this.currentCamera.position.y);
                    console.log('z :' + this.currentCamera.position.z);
                }
            }
        });
    }
}
